import React from 'react';
import {Heading} from 'wix-style-react';

import {useTranslate} from '@wix/premium-bricks-translate';

import s from './WhoisInfo.scss';

export interface WhoisInfoViewProps {
  dataHook: string;
  whoisInfo: string;
  domainName?: string | null;
}

export const WhoisInfo = (props: WhoisInfoViewProps) => {
  const {t} = useTranslate();
  const {whoisInfo, dataHook, domainName} = props;

  return (
    <div className={s.root} data-hook={dataHook}>
      <div className={s.titleWrapper}>
        <Heading appearance="H5" dataHook="whois-info-title">
          {t('whois.result_info.title')}
        </Heading>
      </div>

      <div className={s.domainNameWrapper}>
        <Heading appearance="H2" ellipsis={true} dataHook="whois-info-domain-name">
          {domainName}
        </Heading>
      </div>

      <pre className={s.whoisInfo} data-hook="whois-info-data" dangerouslySetInnerHTML={{__html: whoisInfo}} />
    </div>
  );
};
